// The Prompt logs sub-tab's page (REQ-244, SCR-593) as both shells mount it at the sub-tab's URL:
// the screen when the org logs prompts and the principal may read them, else the reason it is
// absent, in the same words on both shells. The tab row hides the sub-tab through the same
// predicate (model.ts `promptLogsVisible`), so the reason shows only to someone who typed or
// bookmarked the address. While the setting loads it is a loading state, and a failed read says
// so with Retry: neither reads as "off".
import type { OrgContext } from "../../api/org-context";
import { Empty, Loading } from "../../primitives/states";
import { promptLogsAbsence, promptLogsAbsentReason, type PromptLogsScope } from "./model";
import { PromptLogsScreen } from "./prompt-logs";

export interface PromptLogsSubTabProps {
  context: OrgContext;
  query: URLSearchParams;
  /** What decides presence; anything but a known pair that allows reading is absent. */
  scope: PromptLogsScope;
  /** Reads the setting again after a failed read (`promptLogging` "failed"). */
  onRetry?: (() => void) | undefined;
}

export function PromptLogsSubTab({ context, query, scope, onRetry }: PromptLogsSubTabProps) {
  const absence = promptLogsAbsence(scope);
  if (absence === null) return <PromptLogsScreen context={context} query={query} />;
  if (absence === "loading") return <Loading label="Checking prompt logging…" />;
  const retry =
    absence === "failed" && onRetry ? (
      <button type="button" class="button button-secondary" onClick={onRetry}>
        Retry
      </button>
    ) : undefined;
  return <Empty message={promptLogsAbsentReason(scope) ?? ""} action={retry} />;
}
